exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-bg {\r\n    background-color: #053c6d;\r\n}\r\n\r\n.register-box{\r\n\twidth: 600px;\r\n}\r\n\r\n.login-box, .register-box {\r\n    background-color: #eee;\r\n    margin-top: 6%;\r\n    border-radius: 10px;\r\n    box-shadow: 3px 4px 9px 0px rgba(0,0,0,0.52);\r\n    display: table;\r\n}\r\n\r\n.countrycode {\r\n    width: 20%;\r\n    float: left;\r\n    border-top-right-radius: 0;border-bottom-right-radius: 0;\r\n}\r\n\r\n.phonenumber {\r\n    width: 80%;\r\n    border-top-left-radius: 0;border-bottom-left-radius: 0;\r\n}\r\n\r\n.password-input {\r\n    position: relative;\r\n  }\r\n  \r\n  .password-toggle {\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 50%;\r\n    -webkit-transform: translateY(-50%);\r\n            transform: translateY(-50%);\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .password-toggle i {\r\n    font-size: 20px;\r\n  }\r\n  \r\n\r\n\r\n  ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/register/register.component.css
// module id = ../../../../../src/app/register/register.component.css
// module chunks = main